/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';

export const groupTableHead = [
  {
    headerName: 'Client/Group ID',
    field: 'groupId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    sort: 'asc',
    sortingOrder: ['desc', 'asc'],
    cellClass: 'frr-ellipsis-text-overlap',
    cellStyle: {
      'border-right-color': Styles.BorderColor,
      display: 'block',
      alignItems: 'center',
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Group Name',
    field: 'groupName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'nameRenderGroup',
    cellClass: 'frr-ellipsis-text-overlap',
    cellStyle: {
      display: 'block',
      alignItems: 'center',
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const superClientModalHead = [
  {
    headerName: 'Client ID',
    field: 'clientId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sort: 'asc',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Client Name',
    field: 'clientName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'nameRenderClient',
    cellClass: 'frr-ellipsis-text-overlap',
    cellStyle: { display: 'block' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const manuFactureHead = [
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    sort: 'asc',
    minWidth: Styles.Width_100,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellClass: 'frr-ellipsis-text-overlap',
    cellStyle: { display: 'block' },
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'nameRenderMFG',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
export const ProviderHead = [
  {
    headerName: 'Provider ID',
    field: 'providedID',
    editable: false,
    sortable: true,
    suppressMenu: false,
    sort: 'asc',
    minWidth: Styles.Width_100,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Provider Name',
    field: 'name',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellClass: 'frr-ellipsis-text-overlap',
    cellStyle: { display: 'block' },
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'nameRenderProvider',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
export const clientGroupPlanHead = [
  {
    headerName: 'Client/Group/Plan',
    field: 'planId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    sort: 'asc',
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Plan Name',
    field: 'planName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'nameRenderPlan',
    cellClass: 'frr-ellipsis-text-overlap',
    cellStyle: { display: 'block' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const contractTableHead = [
  {
    headerName: 'Contract ID',
    field: 'contractNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    sort: 'asc',
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellClass: 'frr-ellipsis-text-overlap',
    cellStyle: { 'border-right-color': Styles.BorderColor, display: 'block' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Contract Name',
    field: 'contractName',
    resizable: false,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'nameRenderContract',
    cellClass: 'frr-ellipsis-text-overlap',
    cellStyle: { display: 'block' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const manuFactureChildHead = [
  {
    headerName: 'Type',
    field: 'contactTypeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    sortingOrder: ['desc', 'asc'],
  },
  {
    headerName: 'Contact Name',
    field: 'contactName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'nameRenderChild',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Corp Name',
    field: 'corpName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: false,
    lastColumn: true,
    columnSpan: 3,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellClass: 'frr-ellipsis-text-overlap',
    cellStyle: { display: 'block' },
    cellRenderer: 'copNameRender',
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
];
